<script>
  import {
    Form,
    Input,
    Row,
    Col,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
  } from "sveltestrap";

  import { _ } from "svelte-i18n";

  import LoginUser from "./LoginUser.svelte";
  
  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;

    body.classList.toggle("sidebar-enable");
    body.classList.toggle("vertical-collpsed");

    if (window.innerWidth >= 992) {
      if (body.getAttribute("data-sidebar-size") == "sm") {
        body.setAttribute("data-sidebar-size", "lg");
      } else {
        body.setAttribute("data-sidebar-size", "sm");
      }
    }
  }

  // export let sidebar = false;
</script>

<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex" style="margin-left: 12px;">
      <!-- LOGO -->
      <!-- <div class="navbar-brand-box"> -->
        <a href="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="/assets/images/klaid-logo.svg" alt="" height="22" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/klaid-logo.png" alt="" height="52" />
            <img src="assets/images/klaid-title.png" alt="" height="52" />
            <img src="assets/images/klaid-year.png" alt="" height="52" />            
          </span>
        </a>

        <a href="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="/assets/images/klaid-logo.svg" alt="" height="22" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/klaid-logo.png" alt="" height="52" />
            <img src="assets/images/klaid-title.png" alt="" height="52" />
            <img src="assets/images/klaid-year.png" alt="" height="52" />            
          </span>
        </a>
      <!-- </div> -->
      <button
        class="btn btn-sm px-3 font-size-16 vertinav-toggle header-item waves-effect"
        id="vertical-menu-btn"
        on:click={tToggle}
      >
        <i class="fa fa-fw fa-bars" />
      </button>

      
    </div>
    <div class="d-flex">
      <LoginUser />
    </div>
  </div>
</header>